import { shouldPollUpload, useSocialUploadPolling } from '@app/modules/social-export/publish';
import { FragmentSocialUploadItemDto } from '@app/modules/fragments/fragment.types';
import { SocialExportUploadItemCard } from './SocialExportUploadItemCard';

interface Props {
  upload: FragmentSocialUploadItemDto;
}

/**
 * Renders a single upload as a card in the panorama. When status is pending, polls via BFF getUploadById.
 * For all statuses renders SocialExportUploadItemCard.
 * Polling is limited to 1 hour from the publication time.
 */
export function SocialExportUploadItem({ upload: initialUpload }: Props) {
  const shouldPoll = shouldPollUpload(initialUpload);

  const polledQuery = useSocialUploadPolling(initialUpload.id, {
    enabled: shouldPoll,
  });

  const upload = shouldPoll ? (polledQuery.data ?? initialUpload) : initialUpload;

  return <SocialExportUploadItemCard upload={upload} />;
}
